(function() {
  function initScentShowcase(root) {
    if (!root || root.dataset.ssInit === '1') return;
    root.dataset.ssInit = '1';

    var wheel = root.querySelector('[data-ss-wheel]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ss-slide]'));
    var prevBtn = root.querySelector('[data-ss-prev]');
    var nextBtn = root.querySelector('[data-ss-next]');
    if (!wheel || slides.length === 0) return;

    slides.forEach(function(slide, sIdx) {
      slide.querySelectorAll('.ss-icon').forEach(function(icon, iIdx) {
        var seed = (sIdx * 17 + iIdx * 31) % 21;
        icon.style.setProperty('--ss-icon-tilt', (seed - 10) + 'deg');
      });
    });

    function offsetWithinSlide(el, slide) {
      var x = 0, y = 0;
      var node = el;
      while (node && node !== slide && slide.contains(node)) {
        x += node.offsetLeft || 0;
        y += node.offsetTop || 0;
        node = node.offsetParent;
      }
      return { x: x, y: y };
    }
    function computeBurstDeltas() {
      var cw = readVar('--ss-card-w', 420);
      var ch = readVar('--ss-card-h', 600);
      slides.forEach(function(slide) {
        slide.querySelectorAll('.ss-icon').forEach(function(icon) {
          var iconW = icon.offsetWidth || 110;
          var iconH = icon.offsetHeight || 110;
          var pos = offsetWithinSlide(icon, slide);
          var iconCenterX = pos.x + iconW / 2;
          var iconCenterY = pos.y + iconH / 2;
          var dx = (cw / 2) - iconCenterX;
          var dy = (ch / 2) - iconCenterY;
          icon.style.setProperty('--burst-dx', dx + 'px');
          icon.style.setProperty('--burst-dy', dy + 'px');
        });
      });
    }
    computeBurstDeltas();

    function readVar(name, fallback) {
      var v = getComputedStyle(root).getPropertyValue(name).trim();
      return v ? parseFloat(v) : fallback;
    }

    function sizeStage() {
      var stage = root.querySelector('.ss-stage');
      if (!stage) return;
      var maxInfoH = 0;
      slides.forEach(function(slide) {
        var info = slide.querySelector('.ss-info');
        if (info) maxInfoH = Math.max(maxInfoH, info.offsetHeight);
      });
      if (!maxInfoH) return;
      var h = readVar('--ss-center-y', -384) + readVar('--ss-radius', 512)
        - readVar('--ss-card-rise', 96) + readVar('--ss-card-h', 472)
        + readVar('--ss-info-gap', 32) + maxInfoH;
      stage.style.height = h + 'px';
    }
    sizeStage();

    // CTA "Add to cart": add the variant currently selected on the product page
    // (the page's main product form), not the section's configured product.
    // Falls back to its own form (section product) when there's no product form.
    var addForm = root.querySelector('[data-ss-form]');
    if (addForm) {
      addForm.addEventListener('submit', function (e) {
        var mainAdd = document.querySelector(
          'product-form [name="add"], form[is="product-form"] [name="add"], [data-type="add-to-cart-form"] [name="add"], .product-form__submit'
        );
        if (mainAdd && !mainAdd.closest('[data-scent-spotlight]')) {
          e.preventDefault();
          mainAdd.click();
        }
      });
    }

    var current = 0;
    var displayed = 0;
    var dragOffset = 0;
    var rafId = null;
    var animFrom = 0, animTo = 0, animStart = 0;
    var ANIM_MS = 700;

    function layout() {
      var radius = readVar('--ss-radius', 900);
      var centerY = readVar('--ss-center-y', -750);
      var stepDeg = readVar('--ss-angle-step', 26);
      var n = slides.length;
      var pos = displayed + dragOffset;

      slides.forEach(function(slide, i) {
        var diff = i - pos;
        while (diff > n / 2) diff -= n;
        while (diff < -n / 2) diff += n;
        var step = diff;
        var thetaDeg = step * stepDeg;
        var theta = thetaDeg * Math.PI / 180;

        var x = radius * Math.sin(theta);
        var y = centerY + radius * Math.cos(theta);

        var absStep = Math.abs(step);
        var opacity = absStep <= 1 ? 1 : Math.max(0, 2 - absStep);

        var scale = 1 - Math.min(1, absStep) * 0.2;

        slide.style.transform = 'translate(' + x.toFixed(2) + 'px, ' + y.toFixed(2) + 'px) rotate(' + (-thetaDeg).toFixed(2) + 'deg) scale(' + scale.toFixed(3) + ')';
        slide.style.opacity = opacity;
        slide.style.pointerEvents = opacity > 0.5 ? '' : 'none';
        slide.classList.toggle('is-active', i === current);
        slide.setAttribute('aria-hidden', i === current ? 'false' : 'true');
      });
    }

    function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

    function triggerLandingSwing(slide) {
      if (!slide) return;
      slide.classList.remove('ss-landing');
      void slide.offsetWidth;
      slide.classList.add('ss-landing');
      setTimeout(function() { slide.classList.remove('ss-landing'); }, 1300);
    }

    function frame(now) {
      var t = Math.min(1, (now - animStart) / ANIM_MS);
      var k = easeOutCubic(t);
      displayed = animFrom + (animTo - animFrom) * k;
      layout();
      if (t < 1) {
        rafId = requestAnimationFrame(frame);
      } else {
        var n = slides.length;
        displayed = ((animTo % n) + n) % n;
        rafId = null;
        layout();
        triggerLandingSwing(slides[current]);
      }
    }

    function animateTo(targetIdx) {
      var n = slides.length;
      var diff = targetIdx - displayed;
      while (diff > n / 2) diff -= n;
      while (diff < -n / 2) diff += n;
      animFrom = displayed;
      animTo = displayed + diff;
      animStart = performance.now();
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(frame);
    }

    function go(idx) {
      var n = slides.length;
      current = ((idx % n) + n) % n;
      dragOffset = 0;
      animateTo(current);
      restartAutoplay();
    }

    function next() { go(current + 1); }
    function prev() { go(current - 1); }

    /* Scent spotlight: navigation arrows, slide-click, keyboard arrows and
       swipe/drag have been removed so the section is a still, single scent. */

    var autoplayTimer = null;
    function restartAutoplay() {
      if (autoplayTimer) clearInterval(autoplayTimer);
      if (root.dataset.autoplay === 'true' && slides.length > 1) {
        var interval = parseInt(root.dataset.autoplayInterval, 10) || 5000;
        autoplayTimer = setInterval(next, interval);
      }
    }
    root.addEventListener('mouseenter', function() { if (autoplayTimer) clearInterval(autoplayTimer); });
    root.addEventListener('mouseleave', restartAutoplay);

    var resizeRaf = null;
    window.addEventListener('resize', function() {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function() {
        computeBurstDeltas();
        sizeStage();
        layout();
      });
    });

    window.addEventListener('load', sizeStage);

    var hasEntered = false;
    var hasNudged = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function onFirstEnter() {
      if (hasEntered) return;
      hasEntered = true;
      slides[current].classList.add('is-active');
      root.classList.add('ss-revealed');
      if (reducedMotion) return;
      triggerLandingSwing(slides[current]);
      if (!hasNudged && window.matchMedia('(max-width: 767px)').matches) {
        hasNudged = true;
        setTimeout(function() {
          var active = slides[current];
          active.classList.remove('ss-nudge');
          void active.offsetWidth;
          active.classList.add('ss-nudge');
          setTimeout(function() { active.classList.remove('ss-nudge'); }, 2100);
        }, 1400);
      }
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) onFirstEnter();
        });
      }, { threshold: 0.25 });
      io.observe(root);
    } else {
      onFirstEnter();
    }

    requestAnimationFrame(layout);
    layout();
    restartAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-scent-spotlight]').forEach(initScentShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    var root = e.target.querySelector('[data-scent-spotlight]');
    if (root) initScentShowcase(root);
  });
  document.addEventListener('shopify:section:unload', function(e) {
    var root = e.target.querySelector('[data-scent-spotlight]');
    if (root) root.dataset.ssInit = '';
  });
  document.addEventListener('shopify:block:select', function(e) {
    var root = e.target.closest('[data-scent-spotlight]');
    var slide = e.target.closest('[data-ss-slide]');
    if (root && slide) {
      var idx = parseInt(slide.dataset.index, 10) || 0;
      var ev = new Event('click', { bubbles: true });
      Object.defineProperty(ev, 'target', { writable: false, value: slide });
      slide.dispatchEvent(ev);
    }
  });
})();
